import {DependencyList, useCallback, useMemo} from 'react';

export function useFilter<T>(content: T[], selector: (item: T) => boolean, deps: DependencyList = []) {
    const predicate = useCallback(selector, deps);
    return useMemo(() => content.filter(predicate), [content, predicate]);
}
